import type { NavigationItemProps } from '@maestro/commerce-blocks/components/navigation-footer/navigation-footer.types'

import { useCallback } from 'react'

import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { EventType } from '@maestro/data-layer'

export const useNavigationItem = ({
  childNode,
  sectionTitle = '',
}: NavigationItemProps) => {
  const { publish } = useEventBusContext()

  const handleClickLink = useCallback(() => {
    if (!childNode.url) {
      return null
    }
    publish(EventType.FOOTER_LINK_CLICKED, {
      level1: sectionTitle,
      level2: childNode.title,
      click_url: childNode.url,
      click_text: childNode.title,
    })

    setTimeout(() => {
      const mainContent = document.querySelector(
        '#main__content'
      ) as HTMLElement
      if (mainContent) {
        mainContent.focus({ preventScroll: true })
      }
    }, 100)
  }, [childNode.title, childNode.url, publish, sectionTitle])

  return { handleClickLink }
}
